define('tracks/track',["require", "exports", "../places/places", "./trackdata-processing"], function (require, exports, places_1, trackdata_processing_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.jumpType = exports.fromJson = exports.TrackImpl = void 0;
    var TrackImpl = /** @class */ (function () {
        function TrackImpl(json) {
            this.track_id = "";
            this.data = [];
            this.labels = {};
            this.stats = undefined;
            this.trim = {};
            this.videoTime = 0;
            this.sustainedComputed = false;
            // Copy all attributes from json to this new track
            Object.assign(this, json);
            (0, trackdata_processing_1.processData)(this);
        }
        /**
         * Get center of track data
         */
        TrackImpl.prototype.center = function () {
            var lat = (this.stats.lat.min + this.stats.lat.max) / 2;
            var lng = (this.stats.lng.min + this.stats.lng.max) / 2;
            if (lat && lng) {
                return { lat: lat, lng: lng };
            }
            else {
                return undefined;
            }
        };
        TrackImpl.prototype.flightMode = function (millis) {
            var _a;
            if (this.stats && this.stats.plan) {
                var segments = this.stats.plan.segments;
                return (_a = segments.find(function (s) { return s.start <= millis && millis <= s.end; })) === null || _a === void 0 ? void 0 : _a.mode;
            }
            else {
                return undefined;
            }
        };
        TrackImpl.prototype.niceString = function () {
            var suitStr = this.suit ? " - " + this.suit : "";
            return ((0, places_1.formatPlace1)(this.place) || this.dateString()) + suitStr;
        };
        TrackImpl.prototype.processSustained = function () {
            if (!this.sustainedComputed) {
                (0, trackdata_processing_1.processSustained)(this);
                this.sustainedComputed = true;
            }
        };
        TrackImpl.prototype.trimmedData = function () {
            var _this = this;
            return this.data.filter(function (point) { return _this.inTrim(point.millis); });
        };
        /**
         * Return true if millis is inside of trim (or trim is undefined)
         */
        TrackImpl.prototype.inTrim = function (millis) {
            if (this.trim.min && this.trim.max) {
                return this.trim.min <= millis && millis <= this.trim.max;
            }
            else {
                return true;
            }
            // return !(millis < this.trim.min || this.trim.max < millis)
        };
        TrackImpl.prototype.segments = function () {
            var trimmed = this.trimmedData();
            if (this.stats.plan) {
                var result = [];
                var _loop_1 = function (segment) {
                    // Make sure there is overlap
                    var startIndex = trimmed.findIndex(function (d) { return segment.start <= d.millis; });
                    var endIndex = trimmed.findIndex(function (d) { return segment.end <= d.millis; });
                    if (startIndex === -1) {
                        startIndex = trimmed.length;
                    }
                    if (endIndex === -1) {
                        endIndex = trimmed.length;
                    }
                    result.push({
                        mode: segment.mode,
                        data: trimmed.slice(startIndex, endIndex + 1)
                    });
                };
                for (var _i = 0, _a = this.stats.plan.segments; _i < _a.length; _i++) {
                    var segment = _a[_i];
                    _loop_1(segment);
                }
                return result;
            }
            else {
                // Just one segment
                return [{
                        mode: "Unknown",
                        data: this.data
                    }];
            }
        };
        TrackImpl.prototype.startPoint = function () {
            if (this.trim.min) {
                return this.trimmedData()[0];
            }
            else if (this.stats.exit) {
                var exit_1 = this.stats.exit;
                var exitIndex = this.data.findIndex(function (d) { return d.millis >= exit_1.millis; });
                return this.data[exitIndex];
            }
            else {
                return this.data[0];
            }
        };
        TrackImpl.prototype.startTime = function () {
            var _a;
            return this.labels.exit || this.trim.min || ((_a = this.stats.exit) === null || _a === void 0 ? void 0 : _a.millis) || this.data[0].millis;
        };
        TrackImpl.prototype.stopTime = function () {
            var _a;
            return this.labels.land || this.trim.max || ((_a = this.stats.land) === null || _a === void 0 ? void 0 : _a.millis) || this.data[this.data.length - 1].millis;
        };
        /**
         * Convert millis to display as track local time in browser.
         * For example, a track recorded at 14:00 EST, stored as 19:00 UTC, shifted to be 14:00 PST for browser.
         * @param millis milliseconds since epoch, in UTC
         * @return date that appears to be track local time in browser
         */
        TrackImpl.prototype.utcToBrowser = function (millis) {
            return new Date(millis + this.timezoneOffsetLocal());
        };
        /**
         * Convert browser date back into UTC millis. Used for mouse focus.
         * @param date a date in current local timezone
         * @return milliseconds since epoch, in UTC
         */
        TrackImpl.prototype.browserToUtc = function (date) {
            return date && date.getTime() - this.timezoneOffsetLocal();
        };
        TrackImpl.prototype.isBASE = function () {
            return this.jumpType !== undefined ? this.jumpType === "BASE" : (0, places_1.isBASE)(this.place);
        };
        /**
         * How much to shift time by to make UTC millis look like track TZ when displayed in browser TZ
         * @return offset in milliseconds
         */
        TrackImpl.prototype.timezoneOffsetLocal = function () {
            if (this.stats && this.stats.time) {
                return new Date(this.stats.time.min).getTimezoneOffset() * 60000 + this.stats.timezone_offset;
            }
            else {
                return 0;
            }
        };
        TrackImpl.prototype.dateString = function () {
            return this.utcToBrowser(this.startTime()).toLocaleString();
        };
        return TrackImpl;
    }());
    exports.TrackImpl = TrackImpl;
    function fromJson(json) {
        // Create a new TrackImpl and copy all attributes from json to new track
        return new TrackImpl(json);
    }
    exports.fromJson = fromJson;
    function jumpType(track) {
        return track.jumpType !== undefined ? track.jumpType : (0, places_1.jumpType)(track.place);
    }
    exports.jumpType = jumpType;
});
//# sourceMappingURL=/assets/javascripts/tracks/track.js.map;
